// Convert RhinoEnv to a type that can be used in the browser
export type RhinoWindowEnv = {
  readonly [K in keyof RhinoEnv]?: string;
};

import type { RhinoAnalyticsBootstrap } from '../analytics/client';

declare global {
  interface Window {
    rhino: {
      env: RhinoWindowEnv;
      analytics?: RhinoAnalyticsBootstrap;
    };
  }
}

const RhinoRuntimeEnv: RhinoEnv = {
  ...window.rhino.env,

  // Compound env vars
  DESIGN_SYSTEM_ENABLED:
    process.env.NODE_ENV === 'development' ||
    String(window.rhino.env.DESIGN_SYSTEM_ENABLED) === 'true'
};
export default RhinoRuntimeEnv;
